import type { SubscriptionsListRow } from "@/admin/entities/subscriptions";
import type { SubscriptionsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: SubscriptionsListRow[];
  count: number;
} {
  const subscriptions = (data as SubscriptionsListQueryType)?.subscriptions;
  if (!subscriptions || !subscriptions.nodes) {
    return { nodes: [], count: 0 };
  }
  return subscriptions;
}

export function mapColumns(subscription: SubscriptionsListRow) {
  return [
    subscription.id,
    subscription.status,
    subscription.currentPeriodEnd,
    // Колонка «Просрочка» рендерится по всей строке (причина и попытка).
    subscription,
    subscription.billingCyclesComplete,
    subscription,
  ];
}
